import {Card} from '@material-ui/core'
import styled from 'styled-components'
import {PostAddRounded, PictureAsPdfRounded} from '@material-ui/icons'

export const FileWrapper = styled(Card)`
  margin-top: 20px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
`

export const DropzoneWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px dashed #909090;
  border-radius: 4px;
  margin-top: 20px;
  padding: 20px;
  ${({ isDragAccept }) => isDragAccept && 'border-color: #5adb82;'}
  ${({ isDragReject }) => isDragReject && 'border-color: #f44336;'}
`

export const PdfIcon = styled(PictureAsPdfRounded)`
  width: 40px;
  height: 40px;
  margin-right: 10px;
  color: #dc3940;
`

export const DropzoneIcon = styled(PostAddRounded)`
  width: 40px;
  height: 40px;
  margin-right: 10px;
  color: #909090;
`

export const DropzoneMessage = styled.span`
  color: #909090;
  font-size: 14px;
  ${({ isDragAccept }) => isDragAccept && 'color: #5adb82;'}
  ${({ isDragReject }) => isDragReject && 'color: #f44336;'}
`
